import { motion } from 'framer-motion';
import React from 'react';

const fadeInOnly = (duration: number, delay: number) => ({
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      delay,
      duration,
      ease: [0.25, 0.25, 0.25, 0.75],
      type: 'tween',
    },
  },
});

type LetterFadeInProps = {
  delayPerLetter?: number;
  durationPerLetter?: number;
  style?: React.CSSProperties;
  text: string;
};

export const LetterFadeIn: React.FC<LetterFadeInProps> = ({
  text,
  durationPerLetter = 0.8,
  delayPerLetter = 0.06,
  style,
}) => {
  let letterIndex = 0;

  return (
    <div style={{ ...style }}>
      {text.split('<br/>').map((line, lineIndex) => (
        <div
          key={lineIndex}
          style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}
        >
          {line.split('').map((char, charIndex) => {
            const currentIndex = letterIndex++;
            return (
              <motion.span
                key={`${lineIndex}-${charIndex}`}
                variants={fadeInOnly(
                  durationPerLetter,
                  currentIndex * delayPerLetter
                )}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                style={{ display: 'inline-block' }}
              >
                {char === ' ' ? '\u00A0' : char}
              </motion.span>
            );
          })}
        </div>
      ))}
    </div>
  );
};
